<h2 mat-dialog-title class="text-2xl">
  @if (issParking() === 1) {
    ¿Desea crear un parqueo?
  } @else {
    ¿Desea crear un nuevo puesto de trabajo?
  }
</h2>
<mat-dialog-content>
  <p></p>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-content-evenly">
  <shared-button
    class="flex"
    mat-dialog-close
    [icon]="'clear'"
    [typeBtn]="'button'"
    [color]="'warn'"
    >Cancelar</shared-button
  >

  <shared-button
    [mat-dialog-close]="true"
    class="flex"
    [icon]="'check'"
    [typeBtn]="'button'"
    [color]="'accent'"
    >Confirmar</shared-button
  >
</mat-dialog-actions>
